import React, { useState } from "react";
import styles from "./TicketSummarySentiment.module.scss";
import { ReactComponent as OpenCircle } from "assets/icons/open-circle.svg";
import { ReactComponent as CloseCircle } from "assets/icons/close-circle-v2.svg";
import { OwnerSummaryTopicMapping } from "appConstants";
import { getTicketLink } from "utils/helpers";

interface ITicketSummarySentimentProps {
    topic: string;
    ticketIds: Array<String>;
    caseNumbers: Array<String>;
    summary: string
}

export const TicketSummarySentiment: React.FC<ITicketSummarySentimentProps> = ({
    topic,
    ticketIds,
    caseNumbers,
    summary
}) => {
    
    // internal state
    const [isOpen, setIsOpen] = useState(false);

    // opens ticket in a new tab
    const goToTicket = (ticketId: string) => {
        window.open(getTicketLink(ticketId), "_blank");
    }

    return (
        <div className={styles.topic} data-testid="ticket-summary-sentiment">

            {/* Topic Name */}
            <div className={styles.name} data-testid="ticket-summary-sentiment-name">
                { (Object.keys(OwnerSummaryTopicMapping).includes(topic)) ? OwnerSummaryTopicMapping[topic as keyof typeof OwnerSummaryTopicMapping]: topic }
            </div>

            {/* Ticket Count/List */}
            <div data-testid="ticket-summary-sentiment-tickets">

                {/* Ticket List */}
                { isOpen && ticketIds.map( (ticketId, idx) => {
                    const isLast = idx === ticketIds.length - 1;
                    return (
                        <span
                            key={idx}
                            onClick={() => goToTicket(ticketId as string) }
                            className={styles.link}
                            >#{ticketId}{ isLast ? "": ","} </span>
                    );
                })}

                {/* Case List */}
                { isOpen && caseNumbers.length &&
                  ([
                    <div className={styles.salesforce}>See also SF Case #(s)</div>,
                    caseNumbers.map( (caseNumber, idx) => {
                        const isLast = idx === caseNumbers.length - 1;
                        return (
                            <span key={idx} >{caseNumber}{ isLast ? "": ","} </span>
                        );
                    })
                  ])
                }

                {/* Ticket Count */}
                { !isOpen && (
                    <span data-testid="ticket-summary-sentiment-count">{ticketIds.length + caseNumbers.length}</span>
                )
                }
            </div>

            {/* Summary */}
            <div data-testid="ticket-summary-sentiment-summary">
                { isOpen ? summary : summary.substring(0,120) + " ..." }
            </div>
            
            <div
                className={styles.toggle}
                onClick={() => setIsOpen(!isOpen)}
                data-testid="ticket-summary-sentiment-toggle"
                >
                { isOpen ? <CloseCircle />: <OpenCircle /> }
            </div>
        </div>
    );
}
